import MobileHomeHotMessage from './MobileHomeHotMessage'
export default MobileHomeHotMessage;
